import script from "./DailyNewOrdersChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyNewOrdersChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyNewOrdersChart.vue?vue&type=style&index=0&id=510be89a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-510be89a"]])

export default __exports__